__turbopack_context__.v({
  "Avatar": "Post-module-scss-module__mo4kEq__Avatar",
  "Fallback": "Post-module-scss-module__mo4kEq__Fallback",
  "Image": "Post-module-scss-module__mo4kEq__Image",
  "autoLink": "Post-module-scss-module__mo4kEq__autoLink",
  "back": "Post-module-scss-module__mo4kEq__back",
  "button": "Post-module-scss-module__mo4kEq__button",
  "col": "Post-module-scss-module__mo4kEq__col",
  "container": "Post-module-scss-module__mo4kEq__container",
  "content": "Post-module-scss-module__mo4kEq__content",
  "divider": "Post-module-scss-module__mo4kEq__divider",
  "footer": "Post-module-scss-module__mo4kEq__footer",
  "inline": "Post-module-scss-module__mo4kEq__inline",
  "name": "Post-module-scss-module__mo4kEq__name",
  "position": "Post-module-scss-module__mo4kEq__position",
  "postContent": "Post-module-scss-module__mo4kEq__postContent",
  "root": "Post-module-scss-module__mo4kEq__root",
  "sub": "Post-module-scss-module__mo4kEq__sub",
  "subItem": "Post-module-scss-module__mo4kEq__subItem",
  "time": "Post-module-scss-module__mo4kEq__time",
  "title": "Post-module-scss-module__mo4kEq__title",
  "topicBadge": "Post-module-scss-module__mo4kEq__topicBadge",
});
